<template>
  <div class="animated fadeIn new_orders">
    <filters :scope="filtersScope"></filters>
    <operators-conversion-tabs/>

    <div class="container__table" style="overflow:hidden; width:100%">
      <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
        <div class="statistic-wrap" v-for="(dataWeek, indexWeek) in rows">
          <div class="card statistic-table" >
              <div class="card-header">
                {{getWeekDaysByWeekNumber(indexWeek)}}
                <div class="card-actions">
                  <button class="btn-close"><i class="fa fa-download"></i></button>
                </div>
              </div>
              <div class="card-block">
                <table class="table">
                  <thead>
                  <tr v-if="headColumns">
                    <th :style="{background: col.color}" v-for="col in headColumns" :colspan="col.colspan">{{ col.label }}</th>
                  </tr>
                  </thead>

                  <tbody>
                    <tr v-for="row in dataWeek">
                      <td style="background: #e0e0e0;">{{ operatorsReturn(row.operator_id) }}</td>
                      <td style="background: #81c784;">{{row.approved}}</td>
                      <td>{{row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'}}</td>
                      <td>{{(row.total - row.paid) > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'}}</td>
                      <td style="background: #b9f6ca;">{{row.paid}}</td>
                      <td>{{row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'}}</td>
                      <td style="background: #bae0ff; white-space: nowrap;">{{row.total_buyout_usd > 0 ? '$ ' + (row.total_buyout_usd / row.paid).toFixed(2) : '$ 0.00'}}</td>
                      <td style="background: #bae0ff; white-space: nowrap;">{{row.local_currency.split(',').length === 1 ? `${row.total_buyout_local} ${localCurrency(row.local_currency)}` : '-'}}</td>
                      <td style="background: #ffd96a; white-space: nowrap;">{{row.approved > 0 ? '$ ' + ((row.total_buyout_usd * ((row.paid / row.approved) * 100)) / 100).toFixed(2) : '$ 0.00'}}</td>
                      <td style="background: #60b3f6; white-space: nowrap;">{{ row.total_buyout_usd > 0 ? '$ ' + (row.paid * (row.total_buyout_usd / row.paid)).toFixed(2) : '$ 0.00'}}</td>
                      <td style="background: #8fbc8f;  white-space: nowrap;">{{approvedFromValid(row.approved, row.total, row.spam)}}</td>
                    </tr>
                  </tbody>


                  <tfoot>
                  <tr v-for="row in dataWeek.total">
                    <th style="background: #e0e0e0;">{{row.label}}</th>
                    <td style="background: #81c784;">{{row.approved}}</td>
                    <td>{{row.total > 0 ? ((row.approved / row.total) * 100).toFixed(1) + '%' : '0%'}}</td>
                    <td>{{row.total > 0 ? ((row.approved / (row.total - row.paid)) * 100).toFixed(1) + '%' : '0%'}}</td>
                    <td style="background: #b9f6ca;">{{row.paid}}</td>
                    <td>{{row.approved > 0 ? ((row.paid / row.approved) * 100).toFixed(1) + '%' : '0%'}}</td>
                    <td style="background: #bae0ff;">{{row.total_bill}}</td>
                    <td style="background: #bae0ff;">{{row.total_local}}</td>
                    <td style="background: #ffd96a;">{{'$ ' + row.total_revenue}}</td>
                    <td style="background: #60b3f6; white-space: nowrap;">{{'$ ' + row.total_all_average}}</td>
                    <td style="background: #8fbc8f; white-space: nowrap;">{{'$ ' + row.approvedFromValid}}</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from '../../../../components/Filters'
import OperatorsConversionTabs from './OperatorsConversionTabs'
import API from '../../../../api/API'
import StatisticTable from '../../../../components/StatisticTable'
import {map} from 'lodash'
import Helper from '../../../../api/Helper'
import moment from 'moment'
import getSymbolFromCurrency from 'currency-symbol-map'
import Storage from '../../../../api/Storage'
export default {
  name: 'NewOrdersWeek',
  components: {StatisticTable, Filters, OperatorsConversionTabs},
  data () {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true,
        byManualFilter: true
      },
      headColumns: [
        {label: this.$root.$t('statistic.operator'), field: 'operator', color: '#e0e0e0'},
        {label: this.$root.$t('statistic.approve'), field: 'approve', colspan: 3, color: '#81c784'},
        {label: this.$root.$t('statistic.buyoutSum'), field: 'buyoutSum', colspan: 2, color: '#b9f6ca'},
        {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2, color: '#bae0ff'},
        {label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead', color: '#ffd96a'},
        {label: this.$root.$t('statistic.total_revenue'), field: 'total_revenue', color: '#60b3f6'},
        {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px', color: '#8fbc8f'}
      ],
      rows: {},
      footColumns: {},
      monthIndex: [
        'Января',
        'Февраля',
        'Марта',
        'Апреля',
        'Мая',
        'Июня',
        'Июля',
        'Августа',
        'Сентября',
        'Октября',
        'Ноября',
        'Декабря'
      ],
      operators: []
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    approvedFromValid (approved, total, spam) {
      return `${((approved / (total - spam)) * 100).toFixed(1)}%`
    },
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const width = scroll - offset
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }
      }
    },
    localCurrency (currency) {
      return getSymbolFromCurrency(currency)
    },
    operatorsReturn (id) {
      return `${Helper.getOperatorLogin(this.operators, id)} ${Storage.developMode ? `(${id})` : ''}`
    },
    getWeekDaysByWeekNumber (week) {
      // eslint-disable-next-line one-var
      let date = moment().isoWeek(week || 1).startOf('week'), weeklength = 7, result = [], month = ''
      while (weeklength--) {
        result.push(date.format('DD'))
        month = date.format('MM')
        date.add(1, 'day')
      }
      return `Неделя с ${result[0]} - ${result[6]} ${this.monthIndex[month - 1]}`
    },
    async calculateRows () {
      this.rows = []
      this.footColumns = []
      this.operators = []
      await API.getOperators(Helper.getCountryList()).then(operators => {
        this.operators = operators.body
      })
      await API.getNewOrdersWeek().then(response => {
        this.rows = response.body
        map(this.rows, arr => {
          let sumApproved = 0
          let sumTotal = 0
          let sumPaid = 0
          let sumSpam = 0
          let sumAverageBill = 0.0
          let currencyArr = []
          let sumAverageBillLocal = 0.0
          let currency = ''
          arr.forEach(d => {
            sumApproved += d.approved
            sumTotal += d.total
            sumPaid += d.paid
            sumSpam += d.spam
            sumAverageBill += d.total_buyout_usd
            sumAverageBillLocal += d.total_buyout_local
            currencyArr.push(d.local_currency)
            currency = d.local_currency
          })
          let newFilterCurrenct = currencyArr.filter((item, index) => {
            return currencyArr.indexOf(item) === index
          })
          // Тотал средний чек выкупа
          let sumAverageBuybackRevenua = Helper.averageBillDayCount(sumAverageBill, sumPaid).replace('$', '').replace(',', '.')
          // Тотал выкуплено процент
          let paidPercentsRevenua = Helper.percents(sumApproved, sumPaid).replace('%', '').replace(',', '.')
          let resultRevenuaLeadAverage = ((sumAverageBuybackRevenua * paidPercentsRevenua) / 100).toFixed(2)
          arr.total = [{
            label: 'Итого',
            total: sumTotal,
            approved: sumApproved,
            paid: sumPaid,
            total_bill: Helper.averageBillDayCount(sumAverageBill, sumPaid),
            total_local: newFilterCurrenct.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumPaid, this.localCurrency(currency)) : '-',
            total_revenue: resultRevenuaLeadAverage,
            total_all_average: (sumPaid * (sumAverageBill / sumPaid)).toFixed(2),
            approvedFromValid: Helper.approvedFromValid(sumApproved, sumTotal, sumSpam)
          }]
        })
        this.$root.$emit('data_loaded')
      }).catch(response => {
        this.loading = false
        this.$notify({
          type: 'danger',
          title: this.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NewOrdersWeek.vue?5b9449c9